// resources
import staffEndpoints from 'api/resources/staff';
import centerEndpoints from 'api/resources/center';

// utils
import { isRoleType } from 'lib/helpers';

// constants
import { ROLES_OBJECT } from 'constants/onBoarding';

import CenterService from 'services/CenterService';
const centerService = CenterService.getInstance();

const { deleteStaff } = staffEndpoints;
const {
  putAvatar,
  getCentersList,
  putAvatarAsTeacher,
  getCentersAsTeacher,
  getCentersAsDirector,
} = centerEndpoints;

const configQuery = {
  retry: false,
  enabled: false,
  // refetchOnMount: false,
  // refetchOnWindowFocus: false,
  // refetchOnReconnect: false,
};

export const deleteDirectorQuery = {
  resource: deleteStaff,
  config: configQuery,
};

export const getCenterQuery = {
  key: 'centers',
  resource: (centerId) => {

    if (isRoleType([ROLES_OBJECT.DIRECTOR.value])) {
      return getCentersAsDirector();
    }

    if (!isRoleType([ROLES_OBJECT.TEACHER.value])) {
      return getCentersList();
    }

    return getCentersAsTeacher(centerId);
  },
  config: configQuery,
};

export const putCenterAvatarQuery = {
  key: 'center-avatar',
  resource: ({ centerId, body }) => {
    const isTeacher = isRoleType([ROLES_OBJECT.TEACHER.value]);
    if (isTeacher) {
      return putAvatarAsTeacher(centerId, body)
      .then(() => {
        centerService.fetchCenters();
      });
    }

    return putAvatar(centerId, body)
    .then(() => {
      centerService.fetchCenters();
    });;
  },
};
